import axios from "axios";
import { useStore } from "vuex";

export default function useTracking() {
  const store = useStore();
  const base_url = store.state.baseUrl;

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const requestWithRetry = async (
    url,
    data = {},
    method = "patch",
    retries = 3,
    delayTime = 1000
  ) => {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        if (method === "patch") {
          await axios.patch(url, data);
        } else if (method === "post") {
          await axios.post(url, data);
        }
        return;
      } catch (error) {
        if (
          error.response &&
          error.response.status === 429 &&
          attempt < retries
        ) {
          console.warn(
            `Retrying request due to rate limit (attempt ${attempt})...`
          );
          await delay(delayTime);
          delayTime *= 2; // Exponential backoff
        }
        if (error.response && error.response.status === 403) {
          console.log("Ad budget exhausted and deactivated");
        } else {
          console.error(`Error making request to ${url}:`, error);
          return;
        }
      }
    }
  };

  const incrementImpressions = async (type, id, metrics = {}) => {
    await requestWithRetry(`${base_url}${type}/${id}/impressions`, metrics);
  };

  const incrementClicks = async (type, id, metrics = {}) => {
    await requestWithRetry(`${base_url}${type}/${id}/clicks`, metrics);
  };

  const recordConversion = async (adId, userId, conversionType) => {
    await requestWithRetry(`${base_url}ads/${adId}/conversions`, {
      user_id: userId,
      conversion_type: conversionType,
    });
  };

  const recordPageView = async (adId, routeName) => {
    await requestWithRetry(
      `${base_url}ads/page-view`,
      {
        ad_id: adId,
        page_name: routeName,
      },
      "post"
    );
  };

  return {
    incrementImpressions,
    incrementClicks,
    recordConversion,
    recordPageView,
  };
}
